var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"counter",style:(_vm.style)},[_c('div',{staticClass:"counter-title"},[_vm._v("\n        "+_vm._s(_vm.translate(_vm.status))+"\n    ")]),_c('div',{staticClass:"counter-content"},[_vm._v("\n        "+_vm._s(_vm.count ? _vm.count : 0)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }